module.exports = __webpack_public_path__ + "img/orbital-collector.d66df497.png";